import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { useDebounce } from "@uidotdev/usehooks";
import { Search } from "lucide-react";
import { useEffect, useState } from "react";
import { SearchInputProps } from ".";

export function SearchInput({
    initialValue = '',
    setValue,
    disabled = false,
    wrapperProps,
    debounceDelay: debounceTime = 0,
    icon,
    placeholder = "Search...",
    ...props
}: SearchInputProps) {
    const [search, setSearch] = useState(initialValue);
    const debounceSearch = useDebounce(search, debounceTime)
    useEffect(() => {
        setValue(debounceSearch);
    }, [debounceSearch, setValue]);
    let Icon: React.ReactNode;
    if (icon === false) {
        Icon = undefined;
    }
    if (icon === undefined) {
        Icon = <Search className="text-gray-400" size={20} />;
    }
    return (
        <div {...wrapperProps} className={cn("w-full relative", wrapperProps?.className)}>
            <Input
                placeholder={placeholder}
                {...props}
                value={search}
                onChange={(e) => setSearch(e.target.value ?? '')}
                type="text"
                className={cn("pe-5 border bg-gray-50", props.className)}
                disabled={disabled}
                name="search"
            />
            {Icon && (
                <span className={cn("absolute top-0 bottom-0 right-0 py-2 px-3 grid place-items-center", {
                    'text-gray-400 cursor-not-allowed': disabled,
                })}>
                    {Icon}
                </span>
            )}
        </div>
    )
}
